import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map, tap } from 'rxjs';

import { Holding } from '@core/models/holding/holding.model';
import { IHolding } from '@core/models/interfaces/holding/holding.interface';
import { ISocialMedia } from '@core/models/interfaces/social-media.interface';
import { SocialMediaItem } from '@core/models/social-media/social-media.model';
import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root',
})
export class GeneralInformationService {
  url = environment.endpoint.assets;

  constructor(private http: HttpClient) {}

  getSocialMediaList(): Observable<SocialMediaItem[]> {
    return this.http
      .get<ISocialMedia>(`${this.url}/conteudo/config/social.json`)
      .pipe(
        map(({ social }: ISocialMedia) =>
          social.map(item => new SocialMediaItem(item))
        )
      );
  }

  getGroupSilvioSantosDetails(): Observable<Holding> {
    return this.http
      .get<IHolding>(`${this.url}/conteudo/gss-holding/gss.json`)
      .pipe(map(response => new Holding(response)));
  }

  getGeneralConditionsFile(eventId: number) {
    const url = `${this.url}/campanhas/${eventId}/condicoes-gerais/Condicoes_Gerais_TPLidercap.pdf`;
    return this.http
      .get(url, {
        headers: {
          Accept: 'application/pdf',
        },
        responseType: 'blob',
      })
      .pipe(
        tap(response => {
          const newBlob = new Blob([response], { type: 'application/pdf' });
          const data = window.URL.createObjectURL(newBlob);
          const link = document.createElement('a');
          link.href = data;
          link.target = '_blank';
          link.download = 'Condicoes_Gerais_TPLidercap.pdf';
          link.dispatchEvent(
            new MouseEvent('click', {
              bubbles: true,
              cancelable: true,
              view: window,
            })
          );

          setTimeout(function () {
            window.URL.revokeObjectURL(data);
            link.remove();
          }, 100);
        })
      );
  }

  getGeneralConditionsHtmlFile(eventId: number) {
    const url = `${this.url}/campanhas/${eventId}/condicoes-gerais/Condicoes_Gerais_TPLidercap.html`;
    return this.http.get(url, {
      responseType: 'text',
    });
  }

  getLegalTermsText() {
    return this.http.get(
      `${this.url}/conteudo/termos/rodape/texto-juridico.html`,
      {
        responseType: 'text',
      }
    );
  }
}
